// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPerCategorySpendLimitPropertyDto
 */
export interface IPerCategorySpendLimitPropertyDto {
    /**
     * 
     * @type {boolean}
     * @memberof IPerCategorySpendLimitPropertyDto
     */
    per_category_spend_limit?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IPerCategorySpendLimitPropertyDto
     */
    per_category_spend_limit_state?: IPerCategorySpendLimitPropertyDtoPerCategorySpendLimitStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IPerCategorySpendLimitPropertyDtoPerCategorySpendLimitStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IPerCategorySpendLimitPropertyDto interface.
 */
export function instanceOfIPerCategorySpendLimitPropertyDto(value: object): value is IPerCategorySpendLimitPropertyDto {
    return true;
}

export function IPerCategorySpendLimitPropertyDtoFromJSON(json: any): IPerCategorySpendLimitPropertyDto {
    return IPerCategorySpendLimitPropertyDtoFromJSONTyped(json, false);
}

export function IPerCategorySpendLimitPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPerCategorySpendLimitPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'per_category_spend_limit': json['per_category_spend_limit'] == null ? undefined : json['per_category_spend_limit'],
        'per_category_spend_limit_state': json['per_category_spend_limit_state'] == null ? undefined : json['per_category_spend_limit_state'],
    };
}

export function IPerCategorySpendLimitPropertyDtoToJSON(json: any): IPerCategorySpendLimitPropertyDto {
    return IPerCategorySpendLimitPropertyDtoToJSONTyped(json, false);
}

export function IPerCategorySpendLimitPropertyDtoToJSONTyped(value?: IPerCategorySpendLimitPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'per_category_spend_limit': value['per_category_spend_limit'],
        'per_category_spend_limit_state': value['per_category_spend_limit_state'],
    };
}

